import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Mail, Phone, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/admin/leads");
      setLeads(data);
    } catch {
      toast.error("Could not load leads.");
    }
  };

  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this lead?")) return;
    await api.delete(`/admin/leads/${id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div data-testid="admin-leads" className="space-y-6">
      <div>
        <div className="section-overline">Inbound</div>
        <h1 className="font-display text-3xl font-semibold text-[#0A1128] mt-2">Leads & Consultations</h1>
        <p className="mt-2 text-slate-600">All consultation, demo and general enquiries submitted via the website.</p>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
        {leads.length === 0 && <div className="p-8 text-center text-sm text-slate-500">No leads yet.</div>}
        {leads.map((l) => (
          <div key={l.id} data-testid={`lead-${l.id}`} className="p-6 border-b border-slate-100 last:border-b-0">
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0">
                <div className="flex items-center gap-3 flex-wrap">
                  <span className="font-display text-xl font-semibold text-[#0A1128]">{l.name}</span>
                  <span className="px-2.5 py-1 rounded-md bg-[#FFF4E5] text-[#CC7000] text-xs font-semibold">{l.interest || "General"}</span>
                  {l.source === "chatbot" && (
                    <span
                      data-testid={`lead-source-${l.id}`}
                      className="px-2.5 py-1 rounded-md bg-blue-50 text-[#1D4ED8] text-xs font-semibold inline-flex items-center gap-1"
                      title="Captured via the GESIL Assistant chatbot"
                    >
                      ✨ From Genie
                    </span>
                  )}
                </div>
                <div className="mt-2 flex flex-wrap gap-4 text-sm text-slate-600">
                  <a href={`mailto:${l.email}`} className="inline-flex items-center gap-2 hover:text-[#FF8C00]"><Mail size={14} /> {l.email}</a>
                  {l.phone && <a href={`tel:${l.phone}`} className="inline-flex items-center gap-2 hover:text-[#FF8C00]"><Phone size={14} /> {l.phone}</a>}
                  {l.organization && <span className="text-slate-500">· {l.organization}</span>}
                </div>
                <p className="mt-3 text-sm text-slate-700 leading-relaxed">{l.message}</p>
                <div className="mt-3 text-xs text-slate-400">{l.created_at}</div>
              </div>
              <button onClick={() => remove(l.id)} className="h-9 w-9 inline-flex items-center justify-center rounded-md border border-slate-200 hover:border-red-500 hover:text-red-500 shrink-0">
                <Trash2 size={14} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
